import { IUser } from '@components/user/IUser';
import {
  requestLogout as userRequestLogout,
  requestSaveUser,
  requestUser as userRequestUser
} from '@components/user/user-service';
import { post } from '@utils/api-client';

export interface ILoginRequest {
  username: string;
  password: string;
}

export interface ILoginResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
}

function getTokenKey() {
  try {
    const key = process.env.REACT_APP_TOKEN;
    if (!key) throw Error(`Must set token variable in .env`);
    return key;
  } catch (error) {
    console.error(error);
  }
  return '';
}

function getToken() {
  return window.localStorage.getItem(getTokenKey());
}

function setToken({ access_token }: ILoginResponse) {
  window.localStorage.setItem(getTokenKey(), access_token);
}

export async function requestUser(): Promise<IUser | undefined> {
  const token = getToken();
  if (!token) {
    return Promise.resolve(undefined);
  }
  try {
    const user = userRequestUser();
    return Promise.resolve(user);
  } catch (error) {
    requestLogout();
    return Promise.reject(error);
  }
}

export async function requestLogin({ username, password }: ILoginRequest) {
  const config = {
    headers: { 'content-type': 'application/x-www-form-urlencoded' }
  };
  const body = `grant_type=password&username=${username}&password=${password}`;

  await post<ILoginResponse>('token', { body, ...config }).then(response =>
    setToken(response)
  );
  requestSaveUser({ name: username });
}

export function requestLogout() {
  window.localStorage.removeItem(getTokenKey());
  userRequestLogout();
  return Promise.resolve();
}
